import React from "react";

import _ from "underscore";

import PropTypes from 'prop-types';

import MultiSelectFilterItem from './MultiSelectFilterItem';
import SearchBox from './SearchBox';

import $ from "jquery";
import "jquery-deparam";

let ITEMS_PAGE_LIMIT = 30;
let ITEMS_INITIAL_OFFSET = 0;

class MultiSelectFilter extends React.Component {
  constructor(...args) {
    super(...args);

    this.removeFilter = this.removeFilter.bind(this);
    this.eventHandler = this.eventHandler.bind(this);
    this._onScroll = this._onScroll.bind(this);
    this._selectAll = this._selectAll.bind(this);
    this._deselectAll = this._deselectAll.bind(this);
    this._toggleDropdown = this._toggleDropdown.bind(this);
    this._handleChange = this._handleChange.bind(this);
    this._handleSearch = this._handleSearch.bind(this);
    this._onApply = this._onApply.bind(this);
    this._onCancel = this._onCancel.bind(this);

    let initialItems = [];
    if (_.isArray(this.props.initialItems) && _.isObject(this.props.initialItems[0])) {
      initialItems = this.props.initialItems.map(function(item) {
        item.checked = true;
        return item;
      });
    }

    this.state = {
      items: initialItems,
      offset: ITEMS_PAGE_LIMIT,
      loading: true,
      maxItems: 0,
      appliedItems: initialItems
    };
  }

  componentDidMount() {
    $('body').on('click', this.eventHandler);

    if (this.props.url) {
      this._fetchItemsFromRemote('', _.isEmpty(this.state.appliedItems));
    } else {
      this._loadItemsFromValues();
    }
  }

  render() {
    return (
      <div className={'multiselect-dropdown-container ' + this.props.name + ' ' + this._additionalStyleClasses()} ref={(c) => { this._thisRef = c; }}>
        {this._renderStackedControlTitle()}
        <div className={"dropdown" + this._isFilterOpen()} >
          <button className='multiselect-dropdown-button btn btn-secondary dropdown-toggle' aria-haspopup='true' aria-expanded='true' onClick={this._toggleDropdown}>
            {this._renderTitlePrefix()}
            {this._renderTitle()}
          </button>
          {this._renderCloseButton()}
          <div className={"multiselect-dropdown-menu dropdown-menu" + this._isFilterOpen()}>
            <SearchBox onChangeCallback={this._handleSearch}/>
            <div className='scrollableList' onScroll={this._onScroll}>
              <div className='multiselect-dropdown-select-actions'>
                <a href="#" className='select-all' onClick={this._selectAll}>Select all</a>
                <span className='separator'>|</span>
                <a href="#" className='deselect-all' onClick={this._deselectAll}>Deselect all</a>
              </div>
              <div className='dropdown-header'>Selected</div>
              {this._renderSelectedItems()}
              <div className='dropdown-header'>Unselected</div>
              {this._getUnselectedItems()}
              {this._getLoadingIndicator()}
            </div>
            {this._renderActionButtons()}
          </div>
        </div>
      </div>
    );
  }

  _renderStackedControlTitle() {
    if (!this.props.hideLabel) {
      return (
        <div className='multiselect-dropdown-title'>
          {this.props.title}
        </div>
      );
    }
  }

  _renderCloseButton() {
    if (this.props.onRemoveFilter) {
      return (
        <a href='#' className='multiselect-dropdown-remove-button' onClick={this.removeFilter}>
          <i className="material-icons icon--remove">close</i>
        </a>
      );
    }
  }

  _isFilterOpen() {
    if (this.props.open) {
      return " show";
    } else {
      return "";
    }
  }

  _selectAll(evt) {
    evt.preventDefault();

    this.setState({
      items: this.state.items.map(function(item) {
        item.checked = true;
        return item;
      })
    });
  }

  _deselectAll(evt) {
    evt.preventDefault();

    this.setState({
      items: this.state.items.map(function(item) {
        item.checked = false;
        return item;
      })
    });
  }

  _handleChange(name, check) {
    var items = this.state.items;
    var targetIndex = _.findLastIndex(items, {
      id: name
    });
    items[targetIndex].checked = !items[targetIndex].checked;
    this.setState({ items: items });
  }

  _handleSearch(query) {
    if (this.props.url) {
      this.setState({
        query: query,
        offset: ITEMS_PAGE_LIMIT
      });
      this._fetchItemsFromRemote(query, false);
    } else {
      let filteredItems = this.props.values.items.filter(item => { return item.text.toLowerCase().indexOf(query.toLowerCase()) >= 0; });
      let filteredSelectedItems = filteredItems.filter(this._isSelected);

      this.setState({
        query: query,
        items: filteredItems,
        appliedItems: filteredSelectedItems
      });
    }
  }

  _isSelected(value) {
    return value.checked;
  }

  _isUnselected(value) {
    return !value.checked;
  }

  _renderSelectedItems() {
    var selectedItems =  this._getSelectedItems().map(function(selectedItem) {
      return (
        <MultiSelectFilterItem key={selectedItem.id} name={selectedItem.id} check={true} description={selectedItem.text} changeCallback={this._handleChange} />
      );
    }.bind(this));

    return (selectedItems.length > 0) ? selectedItems : (<div className='text-muted mb-small'>No items selected</div>);
  }

  _getSelectedItems() {
    return this.state.items.filter(this._isSelected);
  }

  _getLoadingIndicator() {
    if (this.state.loading === true) {
      return (<div>Loading more items...</div>);
    }
  }

  _getNoItemsAvailableIndicator() {
    if (this.state.loading === false) {
      return (<div className='text-muted js-no-items'>No items available</div>);
    }
  }

  _getUnselectedItems() {
    var unselected = this.state.items.filter(this._isUnselected);
    if (_.isEmpty(unselected)) {
      return this._getNoItemsAvailableIndicator();
    } else {
      return unselected.map(function(selectedItem) {
        return (
          <MultiSelectFilterItem key={selectedItem.id} name={selectedItem.id} check={false} description={selectedItem.text} changeCallback={this._handleChange} />
        );
      }.bind(this));
    }
  }

  _toggleDropdown(evt) {
    evt.preventDefault();

    var $dropdown = $(this._thisRef).find(".dropdown");
    if ($dropdown.hasClass('show')) {
      this._hideMenu();
    } else {
      this._showMenu();
    }
  }

  eventHandler(e) {
    var $dropdown = $(this._thisRef).find(".dropdown");
    if (!$dropdown.is(e.target) &&
      $dropdown.has(e.target).length === 0 &&
      $dropdown.hasClass('show')
    ) {
      if (!_.isUndefined(this.props.onBlur)) {
        this.setState({
          appliedItems: this._getSelectedItems(),
          offset: ITEMS_PAGE_LIMIT
        });
        this.props.onBlur(this._getSelectedItems(), this.props.name);
      }
      this._hideMenu();
    }
  }

  componentWillUnmount() {
    $('body').off('click', this.eventHandler);
  }

  _requestHeaders() {
    var requestHeaders = {
      'X-Select2': '1'
    };

    if (this.props.isReportFilter !== false) {
      requestHeaders['X-Report-Filter'] = '1';
    }

    return requestHeaders;
  }

  _loadItemsFromValues() {
    if (typeof this.props.initialItems !== 'undefined') {
      let selectedItems = [];

      this.props.initialItems.forEach(item => {
        // initial items are just an array of IDs, for local lists we need to convert to array of hashes
        //  using the friendly name from the full list
        let selectedItem = _.findWhere(this.props.values.items, { id: item }) || { text: item };
        selectedItems.push({ id: item, text: selectedItem.text });
      });

      this.props.values.selected_items = selectedItems;
    }

    this._setCheckStatus(this.props.values);
  }

  _fetchItemsFromRemote(query = '', useInitial = true) {
    var urlArray = this.props.url.split('?');
    var params = $.deparam(urlArray[1] || '');
    params.limit = ITEMS_PAGE_LIMIT;
    params.query = query;
    params.start = ITEMS_INITIAL_OFFSET;
    if (typeof this.props.initialItems !== 'undefined' && useInitial) {
      params.selected_ids = this.props.initialItems;
    }
    var url = urlArray[0] + '?' + $.param(params);
    $.ajax({
      url: url,
      headers: this._requestHeaders(),
      success: function(data) {
        data.items = this._itemsWithStringNull(data.items);
        data.selected_items = this._itemsWithStringNull(data.selected_items);
        this._setCheckStatus(data);
      }.bind(this)
    });
  }

  _itemsWithStringNull(data) {
    return _.map(data, function(row) {
      if (row.id === null) {
        row.id = 'null';
      }
      return row;
    });
  }

  // unlike fetch items, onInfiniteload concatenates new data in
  _onInfiniteScroll() {
    var urlArray = this.props.url.split('?');
    var params = $.deparam(urlArray[1]);
    params.limit = ITEMS_PAGE_LIMIT;
    params.query = this.state.query;
    params.start = this.state.offset;
    var url = urlArray[0] + '?' + $.param(params);
    this.setState({
      loading: true
    });
    $.ajax({
      url: url,
      headers: this._requestHeaders(),
      success: function(data) {
        var items = this._itemsWithStringNull(this.state.items.concat(data.items));
        var newOffset = this.state.offset + ITEMS_PAGE_LIMIT;
        this.setState({
          items: this._enforceUniqueItems(items),
          offset: newOffset,
          loading: false,
          maxItems: data.total_results
        });
      }.bind(this)
    });
  }

  _setCheckStatus(data) {
    // get the current selected items
    var selectedItems = this._getSelectedItems();

    // Push the pre-selected items that came in the url params, if they did
    // and mark them as checked
    if (typeof data.selected_items !== 'undefined') {
      data.selected_items = data.selected_items.map(function(item) {
        item.checked = true;
        return item;
      });
      selectedItems = this._enforceUniqueItems(selectedItems.concat(data.selected_items || []));
    }

    // get the available items off the server, server doesn't know about checked or not
    var itemPool = data.items || [];

    // remove selected items off the item pool
    for (var i = 0; i < selectedItems.length; i++) {
      itemPool = _.reject(itemPool, function(item) {
        return item.id === selectedItems[i].id;
      });
    }

    // now make what's left of itemPool values false
    itemPool.map(function(item) {
      item.checked = false;
      return item;
    });

    this.setState({
      items: selectedItems.concat(itemPool),
      appliedItems: selectedItems,
      loading: false,
      maxItems: data.total_results
    });
  }

  _renderTitle() {
    var selectedItems = this._getSelectedItems();
    if (selectedItems.length === 0) {
      return <span className="multiselect-dropdown-placeholder-text">Select {this.props.title}</span>;
    } else if (selectedItems.length === 1) {
      switch (selectedItems[0].text) {
      case "":
        return <span>(Blank)</span>;
      case null:
        return <span>(Not Present)</span>;
      default:
        return selectedItems[0].text;
      }
    } else {
      if (this._showAllItemsSelectedText()) {
        return this.props.allSelectedText;
      } else {
        return `${selectedItems.length} selected`;
      }
    }
  }

  _renderTitlePrefix() {
    var selectedItems = this._getSelectedItems();
    if (this.props.hideLabel && !this.props.hideTitlePrefix && selectedItems.length > 0) {
      return <span className="multiselect-dropdown-placeholder-text">{this.props.title}: </span>;
    } else {
      return '';
    }
  }

  _showAllItemsSelectedText() {
    var selectedItems = this._getSelectedItems();
    return selectedItems.length === this.state.items.length && this.props.allSelectedText;
  }

  _additionalStyleClasses() {
    if (this.props.fixedWidth) {
      return 'fixed-width';
    } else {
      return '';
    }
  }

  // On apply, hide menu, fetch items to rehydrate list, execute callback and update appliedItems
  _onApply(evt) {
    evt.preventDefault();
    this.setState({
      appliedItems: this._getSelectedItems(),
      offset: ITEMS_PAGE_LIMIT
    });
    this._hideMenu();
    this.props.onApply(this._getSelectedItems(), this.props.name);
    if (this.props.url) {
      this._fetchItemsFromRemote('', false);
    }
  }

  _onCancel(evt) {
    evt.preventDefault();

    if (this.props.url) {
      // todo refactor next time in here - noticed on tail end of QA this existing logic, not sure why the below logic exists
      // this control should take a snapshot of the items on open (or on data fetches) and then cancel should rollback
      // to the latest known selection state
      this.setState({
        items: this.state.appliedItems,
        offset: ITEMS_PAGE_LIMIT
      });
      this._fetchItemsFromRemote('', false);
    }

    // for now local lists just stay as is (no filter change event fires, but selections while control was open since
    // last apply is not rollbacked - see above todo for cleaning this up for ajax & local lists
    this._hideMenu();
    if (_.isEmpty(this.state.appliedItems) && this.props.onRemoveFilter) {
      this.removeFilter(evt);
    }
  }

  removeFilter(evt) {
    evt.preventDefault();
    this.props.onRemoveFilter(this.props.name);
  }

  _hideMenu() {
    var $multiSelectFilter = $(this._thisRef);
    $multiSelectFilter.find('.multiselect-dropdown-searchbox input').val('');
    $multiSelectFilter.find('.dropdown').removeClass('show');
    $multiSelectFilter.find('.dropdown-menu').removeClass('show');
  }

  _showMenu() {
    var $multiSelectFilter = $(this._thisRef);
    $multiSelectFilter.find('.dropdown').addClass('show');
    $multiSelectFilter.find('.dropdown-menu').addClass('show');
  }

  _onScroll(event) {
    var $list = $(event.target);
    var delta = $list[0].scrollHeight - $list.scrollTop();
    if (delta < 500 && this.state.maxItems > this.state.items.length && this.state.loading === false) {
      this._onInfiniteScroll();
    }
  }

  _enforceUniqueItems(items) {
    return _.uniq(items, 'id');
  }

  _canFilter() {
    if (this.props.canFilter) {
      return this.props.canFilter(this._getSelectedItems(), this.props.name);
    } else {
      return true;
    }
  }

  _renderActionButtons() {
    if (!_.isUndefined(this.props.hideActionButtons) && this.props.hideActionButtons) {
      return <div></div>;
    } else if (this._canFilter()) {
      return (
        <div className='multiselect-dropdown-menu-footer form-group'>
          <button className='btn multiselect-dropdown-menu-button test-multiSelectApply btn-primary' name='button' type='submit'
            onClick={this._onApply}>Apply
          </button>
          <button className='btn multiselect-dropdown-menu-button test-multiSelectCancel btn-secondary' name='button' type='submit'
            onClick={this._onCancel}>Cancel
          </button>
        </div>
      );
    } else {
      return (
        <div>
          <div className='multiselect-dropdown-menu-footer form-group'>
            <button className='btn multiselect-dropdown-menu-button test-multiSelectApply btn-primary disabled' name='button'
              type='submit'>Apply
            </button>
            <button className='btn multiselect-dropdown-menu-button test-multiSelectCancel btn-secondary' name='button' type='submit'
              onClick={this._onCancel}>Cancel
            </button>
          </div>
          <div className='multiselect-dropdown-alert'>
            <div className='alert alert-danger' role='alert'>Too many filters! Up to {this.props.maxItems || 150} filters are supported.
            </div>
          </div>
        </div>
      );
    }
  }
}

MultiSelectFilter.propTypes = {
  name:           PropTypes.string,
  title:          PropTypes.string,
  allSelectedText: PropTypes.string,
  canFilter:      PropTypes.func,
  url:            PropTypes.string,
  fixedWidth:      PropTypes.bool,
  hideActionButtons: PropTypes.bool,
  hideLabel:      PropTypes.bool,
  hideTitlePrefix: PropTypes.bool,
  isReportFilter:  PropTypes.bool,
  open:           PropTypes.bool,
  show:           PropTypes.bool,
  values:         PropTypes.shape({
    items: PropTypes.arrayOf(
      PropTypes.shape({
        id:   PropTypes.node.isRequired,
        text: PropTypes.string.isRequired
      })
    ).isRequired,
    selected_items: PropTypes.arrayOf(
      PropTypes.shape({
        id:   PropTypes.node.isRequired,
        text: PropTypes.string.isRequired
      })
    )
  }),
  initialItems:   PropTypes.array,
  maxItems:       PropTypes.number,

  onApply:        PropTypes.func,
  onBlur:         PropTypes.func,
  onRemoveFilter: PropTypes.func
};

export default MultiSelectFilter;
